<template>
  <section :key="showMenu" class="font-berthold-force">
    
    <!-- loading -->
    <Loading />

    <!-- menu -->
    <section v-if="showMenu">
      <DesktopMenu v-if="!isMobile" />

      <MobileMenu v-else />
    </section>

    <main class="min-h-[80vh] bg-[#000000]">
      <RouterView class="router-view" v-slot="{ Component }">
        <Transition mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </main>

    <!-- footer -->
    <section v-if="showMenu">
      <Footer />
    </section>

  </section>
</template>

<script setup>
import Loading from '@/shared/components/Loading.vue'
import { RouterView, useRoute } from 'vue-router'
import DesktopMenu from './shared/layout/auth/components/DesktopMenu.vue'
import MobileMenu from './shared/layout/auth/components/MobileMenu.vue'
import { computed } from 'vue'

import Footer from './shared/components/Footer.vue'

const r = useRoute()
const isMobile = computed(() => window.innerWidth < 768)
const showMenu = computed(() => {
  if (r.name !== 'login' && r.name !== 'auth') {
    return true
  }

  return false
})

</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
